<template>
  <IconMenu>
    <List>
      <ListItem @click="$emit('similarDocuments')">
        <template slot="icon">
          <v-icon>zoom_in</v-icon>
        </template>
        {{ $t('globals.similarDocuments') }}
      </ListItem>
      <ListItem @click="$emit('addTo')" :disabled="disableAddTo">
        <template slot="icon">
          <v-icon style="transform: scaleX(-1);">
            reply
          </v-icon>
        </template>
        {{ $t('actions.share') }}
      </ListItem>
    </List>
  </IconMenu>
</template>

<script>
import ListItem from '@/shared/components/list/ListItem';
import List from '@/shared/components/list/List';
import IconMenu from '@/shared/components/dialog/IconMenu';

export default {
  name: 'HorizontalCardMenu',
  components: {
    ListItem,
    List,
    IconMenu,
  },
  props: {
    size: {
      type: Number,
      default: 24,
    },
    document: {
      type: Object,
      required: true,
    },
    allowAddingToReflection: {
      type: Boolean,
      default: true,
    },
    disableAddTo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showActionsMenu: false,
    };
  },
};
</script>
